import { twMerge } from "tailwind-merge";
import { IconsProps } from ".";

export const Cash = ({
  className = "text-primary",
  viewBox = "0 0 32 24",
  width = 32,
  height = 24,
  onClick,
}: IconsProps) => (
  <svg
    className={twMerge("cursor-pointer", className)}
    viewBox={viewBox}
    width={`${width}px`}
    height={`${height}px`}
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <title>Cash</title>
    <path
      d="M26.209 14.8337V3.50033C26.209 1.94199 24.934 0.666992 23.3757 0.666992H3.54232C1.98398 0.666992 0.708984 1.94199 0.708984 3.50033V14.8337C0.708984 16.392 1.98398 17.667 3.54232 17.667H23.3757C24.934 17.667 26.209 16.392 26.209 14.8337ZM23.3757 14.8337H3.54232V3.50033H23.3757V14.8337ZM13.459 4.91699C11.1073 4.91699 9.20898 6.81533 9.20898 9.16699C9.20898 11.5187 11.1073 13.417 13.459 13.417C15.8107 13.417 17.709 11.5187 17.709 9.16699C17.709 6.81533 15.8107 4.91699 13.459 4.91699ZM31.8757 4.91699V20.5003C31.8757 22.0587 30.6007 23.3337 29.0423 23.3337H4.95898C4.95898 21.917 4.95898 22.0587 4.95898 20.5003H29.0423V4.91699C30.6007 4.91699 30.459 4.91699 31.8757 4.91699Z"
      fill="currentColor"
    />
  </svg>
);
